import React from "react";
import ReactDOM from "react-dom";

const Portal = ({ children, onClose, isOpened }) =>
  isOpened
    ? ReactDOM.createPortal(
        <div
          style={{
            position: "fixed",
            top: "0",
            bottom: "0",
            left: "0",
            right: "0",
            display: "grid",
            justifyContent: "center",
            alignContent: "start",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1050,
            overflowY: "auto",
            paddingTop: "2rem",
            paddingBottom: "2rem",
          }}
          /*   onClick={()=>{onClose()}} */
        >
          <div
            style={{
              padding: 20,
              background: "#fff",
              borderRadius: "12px",
              display: "inline-block",
              margin: "1rem",
              position: "relative",
              minWidth: "500px",
              maxWidth: "90vw",
              boxShadow:
                "0 10px 30px rgba(0,0,0,0.3), 0 3px 6px rgba(0,0,0,0.2)",
              justifySelf: "center",
            }}
          >
            {children}
          </div>
        </div>,
        document.getElementById("portal-root")
      )
    : null;

export default Portal;
